module.exports = __webpack_public_path__ + "static/media/right.a9a1f324.png";